/**
 * Main functionality for Login Radius integration.
 * -------
 * This file is rendered within login-radius-head.liquid,
 * and is used primarily on login-radius-login.liquid.
 */

function initializeLoginRadius() {
  // Debug flag, this'll turn on/off the logs.
  var debug = false;

  var selectors = {
    loader: '#loading-spinner',
    feedback: '[data-form-feedback]',
    // Classes used in the enhance____ methods
    inputGroup: '.loginradius--form-element-content', // the 'form-group' of LR's default forms
    inputTypes: {
      checkbox: 'input[type="checkbox"]',
      text:
        'input[type="text"], input[type="password"], input[type="email"], input[type="date"]',
      buttons: 'button, input[type="submit"], .loginradius-submit'
    },
    forgotPassToggle: '[data-form-toggle="forgot-password"]',
    // These are 'sections' within the page, that get toggled based on the page state.
    // Only one is ever visible at a time. (see `showSection` method)
    sections: {
      main: '[data-form-section="main"]',
      resetPass: '[data-form-section="reset-password"]',
      noEmail: '[data-form-section="no-email"]',
      verifyEmail: '[data-form-section="verify-email"]'
    },
    // These are the 'containers' around the forms (not the forms themselves)
    formContainers: {
      login: '[data-form="login"]',
      registration: '[data-form="registration"]',
      forgotPass: '[data-form="forgot-password"]'
    },
    // The actual <form> elements, injected by Login Radius's JS
    forms: {
      login: 'form[name="loginradius-login"]',
      registration: 'form[name="loginradius-registration"]',
      forgotPass: 'form[name="loginradius-forgotpassword"]',
      resetPass: 'form[name="loginradius-resetpassword"]'
    }
  };

  var classes = {
    feedback: {
      success: 'loginradius-raas-success-message',
      error: 'loginradius-raas-error-message'
    }
  };

  /**
   * ==========================================================
   * Utility Functions
   * -----------
   * Various utility methods used by this the Login Radius
   * integration.
   *
   * Note: These are all contained within an IIFE, so you can't
   * access them directly without exposing them to the global
   * namespace.
   * ==========================================================
   */

  /**
   * Renders logs to the console if debug = true.
   * @param {String, Object} message
   */
  function log(message) {
    if (message && debug) {
      var prefix = '[LoginRadius] - ';
      switch (typeof message) {
        case 'object':
          console.log(prefix + JSON.stringify(message));
          break;
        default:
          console.log(prefix + message);
      }
    }
  }

  /**
   * Renders feedback into a predefined element on the page.
   * Passing a blank string msg hides the feedback container.
   * @param {String} msg
   * @param {String} state One of [null, 'error', 'success'].
   */
  function renderFeedback(msg, state) {
    var $feedback = $(selectors.feedback);
    $feedback.removeClass([classes.feedback.success, classes.feedback.error]);
    switch (state) {
      case 'error':
        $feedback.addClass(classes.feedback.error);
        break;
      case 'success':
        $feedback.addClass(classes.feedback.success);
        break;
    }

    if (msg) {
      // Note - needs to be HTML in case the error contains HTML markup.
      $feedback.html(msg).show();
    } else {
      $feedback.hide();
    }
  }

  /**
   * Gets a URL Query param by name
   * @param {String} name
   * @returns {String} the value of the query param for that name
   */
  function getParameterByName(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
      results = regex.exec(location.search);
    return results === null
      ? ''
      : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  /**
   * Provided a LoginRadius access token, exchanges it for a multipass
   * URL the user is then redirected to.
   *
   * Note: This method ends in a window location redirect.
   *
   * @param {String} token
   * @returns {Deferred} jQuery ajax call.
   */
  function exchangeMultipassToken(token) {
    var apiUrl =
      'https://cloud-api.loginradius.com/sso/shopify/api/token?store=' +
      lrshopifystore;
    if (getParameterByName('checkout_url')) {
      // apiUrl = apiUrl + '&return_url=' + getParameterByName('checkout_url');
      apiUrl = apiUrl + '&return_url=' + getParameterByName('checkout_url').split(window.location.host).pop();
    }

    return $.ajax({
      url: apiUrl,
      type: 'GET',
      dataType: 'json',
      headers: {
        Authorization: 'Bearer ' + token,
        'X-LoginRadius-ApiKey': raasoption.apiKey
      },
      success: function(response) {
        log('Exchange Multipass Token Success');
        log(response);
        window.location = response.url;
      }
    });
  }

  /**
   * Toggles the forgot password form (which usurps the
   * login form's location).
   * @param {Boolean} isVisible - pass a boolean to forcibly show (true) or hide (false) the forgot password form.
   */
  function toggleForgotPassword(isVisible) {
    if (isVisible == undefined) {
      $(selectors.formContainers.login).toggle();
      $(selectors.formContainers.forgotPass).toggle();
    } else {
      $(selectors.formContainers.login).toggle(!isVisible);
      $(selectors.formContainers.forgotPass).toggle(!!isVisible);
    }
  }

  /**
   * Method to trigger the Login Radius logout flow.
   *
   * This method is used by both this file as well as
   * login-radius-footer.liquid.
   */
  function logout() {
    var logout_options = {
      onSuccess: function(response) {
        // Successfully logged out.
        log('Logging out.');
        log(response);
        // raas-settings.js is a plain asset, so Liquid is not rendered here;
        // login-radius-head.liquid provides the route.
        window.location = window.lrLogoutUrl || '/account/logout';
      }
    };

    // Execute logout
    LRObject.init('logout', logout_options);
  }

  /**
   * Shows the designated form section, while hiding all others.
   * @param {String} sectionName key name from the selectors.sections object
   */
  function showFormSection(sectionName) {
    if (!selectors.sections) return;

    var sections = Object.keys(selectors.sections);

    if (sections.indexOf(sectionName > -1)) {
      var sectionNamesToHide = sections.filter(function(sn) {
        return sn !== sectionName;
      });
      var sectionsToHide = sectionNamesToHide.map(function(sn) {
        return selectors.sections[sn];
      });

      // Hide all other sections, while revealing the passed section.
      $(sectionsToHide.join(', ')).hide();
      $(selectors.sections[sectionName]).show();
    }
  }

  /**
   * Adds classes to a Login Radius input to match the theme styles.
   * @param {jQuery} $input - the text input to be enhanced
   */
  function enhanceTextInput($input) {
    if (!$input || !$input.is(selectors.inputTypes.text)) {
      log('Unexpected input type');
      return;
    }
    var $container = $input.closest(selectors.inputGroup);
    $container.addClass('form-group');
    $input.addClass('form-control');
  }

  /**
   * Enhances a Login Radius checkbox to be more like the theme's custom checkboxes
   * @param {jQuery} $input - the checkbox input to be enhanced
   */
  function enhanceCheckbox($input) {
    if (!$input || !$input.is(selectors.inputTypes.checkbox)) {
      log('Unexpected input type');
      return;
    }
    var $container = $input.closest(selectors.inputGroup);
    var $label = $container.find('label');
    $container.removeClass().addClass('custom-control custom-checkbox');
    $input.removeClass().addClass('custom-control-input');
    $label.removeClass().addClass('custom-control-label');
  }

  /**
   * Removes all native classes, adding theme-specific ones.
   * @param {jQuery} $btn - the button to be enhanced
   */
  function enhanceButton($btn) {
    if (!$btn || !$btn.is(selectors.inputTypes.buttons)) {
      log('Unexpected input type');
      return;
    }
    $btn.removeClass().addClass(['btn', 'btn-primary']);
  }

  // Expose methods to the window so that they can be used
  // in `snippets/login-radius-footer.liquid`
  window.lr_utils = {
    exchangeMultipassToken: exchangeMultipassToken,
    logout: logout
  };

  // ==========================================================
  // Hooks
  // -----------
  // Bind some 'hooks' to take action at various points in the
  // lifecycle
  // ==========================================================

  // Hook to override the labels of a given form (by input name)
  // The LoginRadius admin doesn't allow labels to contain HTML, so this allows us to add a link
  LRObject.$hooks.call('customizeFormLabel', {
    emailid: 'Email',
    cf_Iagreetotermsandcond:
      'I agree that I am over the age of 18 or have obtained parental permission to enter this site and I agree to the <a target="_BLANK" href="//www.toneitup.com/terms-and-conditions/">Terms and Conditions.</a>'
  });

  // Hook to override the CTA text for each form
  LRObject.$hooks.call('setButtonsName', {
    login: 'Sign in',
    registration: 'Create Account'
  });

  // Hook is called when a Login Radius process (form initialization, api method) begins
  LRObject.$hooks.register('startProcess', function(data) {
    // Do something
  });

  // Hook is called when a Login Radius process (form initialization, api method) ends
  LRObject.$hooks.register('endProcess', function(data) {
    // Do something
  });

  // Triggered directly before a Login Radius form is rendered to the DOM
  LRObject.$hooks.register('beforeFormRender', function(name, schema) {
    //
  });

  // Triggered directly after a Login Radius form is rendered to the DOM
  LRObject.$hooks.register('afterFormRender', function(name, schema) {
    var $form = $('form[name="loginradius-' + name + '"]');
    log(name + ' form rendered.');

    if ($form.length && !$form.hasClass('enhanced')) {
      // Enhance inputs and aling them to this theme's styleguide.
      var $textInputs = $form.find(
        'input[type="text"], input[type="password"], input[type="email"]'
      );
      $textInputs.each(function(i, el) {
        enhanceTextInput($(el));
      });
      var $checkboxInputs = $form.find('input[type="checkbox"]');
      $checkboxInputs.each(function(i, el) {
        enhanceCheckbox($(el));
      });
      var $buttons = $form.find(
        'button, input[type="button"], input[type="submit"]'
      );
      $buttons.each(function(i, el) {
        enhanceButton($(el));
      });

      // Add class to avoid attempting to enhance a single form twice
      $form.addClass('enhanced');
    }
  });

  // ==========================================================
  // Event Handlers
  // -----------
  // These should be done in section scripts, but leaving here
  // for now.
  // ==========================================================

  // Event handler - toggle forgot password
  // (delegated in case the link gets async added to the DOM)
  $('body').on('click', selectors.forgotPassToggle, function(e) {
    toggleForgotPassword();
  });

  // ==========================================================
  // Ready Handler
  // -----------
  // Once the Login Radius client SDK is ready, this handler
  // executes.
  // ==========================================================
  LRObject.util.ready(function() {
    /**
     * Initialize all the LR form components
     * ----
     * Note that most of these forms only get initialized if there's
     * a boolean flag set to true on the window object.  Some (reset
     * password, verify email) require specific parameters be present
     * in the URL.
     */

    // Get LR configuration settings (assembled in `login-radius-login.liquid`)
    window.lr_form_settings = window.lr_form_settings || {};

    // Registration...
    if (window.lr_form_settings.registration) {
      registration_options.container =
        window.lr_form_settings.registration_containerid;
      LRObject.init('registration', registration_options);
    }

    // Login...
    if (window.lr_form_settings.login) {
      login_options.container = window.lr_form_settings.login_containerid;
      LRObject.init('login', login_options);
    }

    // Forgot password...
    if (window.lr_form_settings.forgotpassword) {
      forgotpassword_options.container =
        window.lr_form_settings.forgotpassword_containerid;
      LRObject.init('forgotPassword', forgotpassword_options);
    }

    // Reset password...
    // Conditionally initialized only if URL contains reset password params
    if (
      getParameterByName('vtype') == 'reset' &&
      getParameterByName('vtoken') &&
      window.lr_form_settings.resetpassword
    ) {
      resetpassword_options.container =
        window.lr_form_settings.resetpassword_containerid;
      LRObject.init('resetPassword', resetpassword_options);
      showFormSection('resetPass'); // Show reset password section
    }

    // Verify Email...
    // Conditionally initialized only if URL contains verify email params
    if (
      getParameterByName('vtype') == 'emailverification' &&
      getParameterByName('vtoken') &&
      window.lr_form_settings.verifyemail
    ) {
      resetpassword_options.container =
        window.lr_form_settings.verifyemail_containerid;
      LRObject.init('verifyEmail', verifyemail_options);
      showFormSection('verifyEmail');
    }

    // Social login...
    if (window.lr_form_settings.sociallogin) {
      raasoption.hashTemplate = true;

      LRObject.customInterface(
        window.lr_form_settings.sociallogin_interfaceid,
        {
          templateName: 'loginradiuscustom_tmpl'
        }
      );

      sl_options.container = window.lr_form_settings.sociallogin_containerid;
      LRObject.init('socialLogin', sl_options);
    }

    /**
     * Birthdate input
     * Commenting this out because `.datepicker()` implies a jQueryUI
     * dependency which this theme does not provide.
     */
    /*
      var maxYear = new Date().getFullYear();
      var minYear = maxYear - 100;
      $('body').on('focus', '.loginradius-raas-birthdate', function() {
        $('.loginradius-raas-birthdate').datepicker({
          dateFormat: 'mm-dd-yy',
          maxDate: new Date(),
          minDate: '-100y',
          changeMonth: true,
          changeYear: true,
          yearRange: minYear + ':' + maxYear
        });
      });
    */
  });

  /**
   * FORM CONFIGURATION OPTIONS
   * ----
   * These are the config options for the forms initialized above.
   *
   * Note that these vars get hoisted, so they're included in the
   * initialization methods even though being placed below them.
   * (the sequence was inherited, so it's being left as is).
   */

  // SSO Login Config
  // (not sure how this differs from the vanilla 'Login' below)
  var ssologin_options = {
    onSuccess: function(response) {
      // On Success
      //Write your custom code here
      log('SSO Login Success');
      log(response);
    }
  };

  LRObject.init('ssoLogin', ssologin_options);

  // Login Config
  var login_options = {
    onSuccess: function(response) {
      log('Login Success');
      exchangeMultipassToken(response.access_token);
    },
    onError: function(errors) {
      renderFeedback(errors[0].Message, 'error');
      log('Login Error');
      log(errors);
    }
  };

  // Forgot Password Config
  var forgotpassword_options = {
    onSuccess: function(response) {
      log('Forgot Password Success');
      if (
        response.IsPosted == true &&
        typeof response.Data !== 'undefined' &&
        response.Data !== null
      ) {
        renderFeedback('OTP has been sent to your phone number.');
      } else if (
        LRObject.options.otpEmailVerification == true &&
        typeof response.Data === 'undefined'
      ) {
        renderFeedback('OTP has been sent to your email address.');
      } else if (
        response.IsPosted == true &&
        typeof response.Data === 'object'
      ) {
        if ($('form[name="loginradius-resetpassword"]').length > 0) {
          renderFeedback('Password has been reset successfully.');
          $('#lr-raas-login').show();
          $('#login-container').show();
          $('#lr-social-traditional-login').show();
          $('#lr-raas-forgotpassword').hide();
        }
      } else if (
        response.IsPosted == true &&
        typeof response.Data === 'undefined'
      ) {
        if ($('form[name="loginradius-resetpassword"]').length > 0) {
          renderFeedback('Password has been reset successfully.');
          $('#lr-raas-login').show();
          $('#login-container').show();
          $('#lr-social-traditional-login').show();
          $('#lr-raas-forgotpassword').hide();
        } else {
          renderFeedback(
            'Password reset information sent to your provided email id, check email for further instructions'
          );
        }
      }

      // Execute custom success handler
      // TODO - Add this to all forms
      if (
        window.lr_form_settings &&
        typeof window.lr_form_settings.forgotpassword_onsuccess === 'function'
      ) {
        window.lr_form_settings.forgotpassword_onsuccess();
      }
    },
    onError: function(errors) {
      log('Forgot Password Error');
      if (errors[0].Description != null) {
        renderFeedback(errors[0].Description, 'error');
      } else if (errors[0] != null) {
        renderFeedback(errors[0].Message, 'error');
      }
    }
  };

  // Verify email config
  var verifyemail_options = {
    onSuccess: function(response) {
      log('Verify Email Success');
      $('#lr-social-traditional-login').hide();
      $('#interfacecontainerdiv').hide();
      $('#no-email-container').show();
      $('#no-email-container h4').hide();

      log(response);
      renderFeedback('Email verified, now you can login');
    },
    onError: function(errors) {
      log('Verify Email Error');
      $('#lr-social-traditional-login').hide();
      $('#interfacecontainerdiv').hide();
      $('#redirectologin').show();
      log(errors);
      renderFeedback(errors[0].Message, 'error');
    }
  };

  // Reset password
  var resetpassword_options = {
    onSuccess: function(response) {
      log('Reset Password Success');
      log(response);
      renderFeedback('Password reset successfully, now you can login');
      $(selectors.forms.resetPass)
        .get(0)
        .reset(); // reset form
      $(selectors.sections.main).show(); // reveal the normal login
      $(selectors.sections.resetPass).hide();
    },
    onError: function(errors) {
      log('Reset Password Error');
      log(errors);
      var error = errors[0] || {};
      var msg =
        error.Description ||
        error.Message ||
        'Something went wrong resetting your password.  Please try again.';
      renderFeedback(msg, 'error');
    }
  };

  // Registration options
  var registration_options = {
    onSuccess: function(response) {
      log('Registration Success');
      log(response);
      var optionalemailverification = '';
      var disableemailverification = '';

      if (typeof LRObject.options.optionalEmailVerification != 'undefined') {
        optionalemailverification = LRObject.options.optionalEmailVerification;
      }
      if (typeof LRObject.options.disabledEmailVerification != 'undefined') {
        disableemailverification = LRObject.options.disabledEmailVerification;
      }

      if (response.IsPosted && response.Data == null) {
        if (
          (typeof optionalemailverification == 'undefined' ||
            optionalemailverification !== true) &&
          (typeof disableemailverification == 'undefined' ||
            disableemailverification !== true)
        ) {
          renderFeedback(
            'Email for verification has been sent to your provided email, please check email for further instructions'
          );
        }
      } else if (response.access_token != null && response.access_token != '') {
        exchangeMultipassToken(response.access_token);
      } else if (
        response.IsPosted &&
        response.Data !== null &&
        response.Data.Sid
      ) {
        renderFeedback('OTP has been sent to your phone number.');
      } else if (
        LRObject.options.otpEmailVerification == true &&
        response.Data == null
      ) {
        renderFeedback('OTP has been sent to your email address.');
      } else {
        renderFeedback(
          'Email for verification has been sent to your provided email, please check email for further instructions'
        );
      }
    },
    onError: function(errors) {
      log('Registration Error');
      log(errors);
      renderFeedback(errors[0].Message, 'error');
    }
  };

  // Social Login
  var sl_options = {
    onSuccess: function(response) {
      log('Social Login Success');
      log(response);
      if (response.IsPosted) {
        //document.getElementsByName("loginradius-socialRegistration")[0].reset();
        renderFeedback(
          'Email for verification has been sent to your provided email, please check email for further instructions'
        );
        $('#interfacecontainerdiv').hide();
      } else {
        exchangeMultipassToken(response.access_token);
      }
    },
    onError: function(errors) {
      log('Social Login Error');
      if (window.isSSORedirectedToken) {
        logout();
      } else {
        renderFeedback(errors[0].Message, 'error');
      }
    }
  };

  // Account Linking
  // No idea what this is.
  var la_options = {
    container: 'interfacecontainerdiv',
    templateName: 'loginradiuscustom_tmpl_link',
    onSuccess: function(response) {
      log(response);
    },
    onError: function(errors) {
      log(errors);
    }
  };
}

// Initialize these components once the theme is ready
// (done this way so they can use the global jQuery from theme.js)
if (window.theme && window.theme.ready) {
  initializeLoginRadius();
} else {
  document.body.addEventListener('theme.ready', initializeLoginRadius);
}
